import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { validateItemName } from "../../utilities/Validation";
import Label from "../label/label";

interface NotificationNameStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (desciption: string) => void;
}

const NotificationNameStep: FC<NotificationNameStepProps> = ({ onNext, onBack, setSideBarStepDescription }) => {
    const { translate } = useLocale();
    const { values, errors } = useFormikContext<any>();

    const onLocalNext = (event: any) => {
        if (values.name) {
            onNext(event);
            setSideBarStepDescription(values.name)
        }
    }

    return (<div className="pt-3 pr-3 pl-3 h-full relative">
        <h1 className={`mb-3 text-portal-blue-primary-shade2 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.setNotificationName)}
        </h1>
        <div className="flex flex-col pt-3">
            <div className="flex flex-row justify-between">
                <Label
                    required
                    htmlFor="name"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.name)}:</Label>
                {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
            </div>
            <Field
                type="text"
                name="name"
                autoFocus
                className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                validate={(value) => validateItemName(value, translate)} />
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>

            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${values?.name.trim() != "" ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    disabled={values?.name.trim() == ""}
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>

    </div>)
}

export default NotificationNameStep;
